import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TextArrayFilterComponent } from '../text-array-filter/text-array-filter.component';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-any-array-filter',
  standalone: true,
  templateUrl: './any-array-filter.component.html',
  imports: [TextArrayFilterComponent, MatFormField, MatLabel, MatSelect, ReactiveFormsModule, MatOption, MatError],
  styleUrl: './any-array-filter.component.scss'
})
export class AnyArrayFilterComponent {
  @Input() paramsGroup!: FormGroup;
  @Input() allowedValues?: string[] | null = null;
}
